import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const postCustomerSurveyResponse: DocumentNode = gql`
  mutation PostCustomerSurveyResponse($surveys: JSON) {
    postCustomerSurveyResponse(input: { surveys: $surveys }) {
      ... on CustomerSurveyResponse {
        success
      }
    }
  }
`

export default postCustomerSurveyResponse
